<!--
RootPage direkt unterhalb von App.vue. Hier stehen das erste Mal die vom Router
übergebenen Properties ca und raid zur Verfügung. Darum wird hier die
Customization geholt. Erst wenn diese da ist, werden Pageheader und router-view
eingebunden, weil sowohl der Header als auch die Seiten in der router-view von
ihr abhängen.
-->
<template>
  <div>
    <page-header v-if="customizationAvailable"></page-header>
    <app-nav v-if="customizationAvailable" id="main-nav"></app-nav>
    <page-footer v-if="customizationAvailable"></page-footer>

    <main id="page-wrap">
      <main id="content-layer" class="container">
        <error-modal ref="messages"></error-modal>
        <!--
          Als Key für <router-view> dient der Name der Route. Bei jeder Änderung
          der Route, bei der ein anderer Name verwendet wird, gibt es dadurch
          einen Reset der aufgerufenen Komponente.

          Fieser Hack: Damit zwischen retrieve-certificate und
          retrieve-certificate-save/done kein Reset passiert, wird das save/done
          abgeschnitten.
        -->
        <router-view
          v-if="customizationAvailable"
          :key="$route.name.replace(/-(save|done)$/, '')"
          @error-message="errorMessage"
        ></router-view>
        <div v-else>
          <error-page404 v-if="error"></error-page404>
          <b-spinner v-else></b-spinner>
        </div>
      </main>
    </main>
  </div>
</template>

<script setup>
import { onBeforeMount, onErrorCaptured, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { Logger } from "@/logger/logger";
import { fetch } from "@/customization/customization";
import ErrorModal from "@/components/ErrorModal.vue";
import PageHeader from "@/components/PageHeader";
import PageFooter from "@/components/PageFooter";
import ErrorPage404 from "@/components/pages/ErrorPage404";
import AppNav from "@/components/AppNav";

const { t } = useI18n()

const log = new Logger("RootPage");
log.debug("Entering RootPage");

const props = defineProps({
  ca: { type: String, default: null },
  raid: { type: Number, default: null }
})

const customizationAvailable = ref(false)
const error = ref(false)
const messages = ref(null)

const errorMessage = (msg) => {
  messages.value.error(msg);
}

onBeforeMount(async () => {
    const caInfo = "CA: '" + props.ca + "', RA-ID: '" + props.raid + "'";
    try {
      await fetch(props.ca, props.raid);
    } catch (e) {
      // TODO: Anhand e.response.status Fehler genauer unterscheiden. (404/503)
      log.error("Fehler beim Holen der Customization für " + caInfo);
      log.error(JSON.stringify(e, null, 2));
      error.value = true;
      return;
    }
    // custom.windowTitle = "blubb"; // Fehler
    customizationAvailable.value = true;
    log.debug("RootPage mounted mit " + caInfo);
})

onErrorCaptured((err, vm, info) => {
   errorMessage(
    t("capturedErrorMsg") +
      "\n\n" +
      t("errorDetails") +
      "\n" +
      err.toString() +
      "\nKomponente: " +
      info
  );
  return false;
})
</script>


<i18n>
en:
  capturedErrorMsg: "An unexpected error occured within the webbrowser during processing or rendering of this webpage."
  error: "Error"
  errorDetails: "Error Details: "
de:
  capturedErrorMsg: "Es ist leider ein unerwarteter Fehler bei der Verarbeitung und Anzeige dieser Webseite im Browser aufgetreten."
  error: "Fehler"
  errorDetails: "Fehlerbeschreibung: "
</i18n>

<style scoped>
#content-layer {
  margin-top: 20px;
  margin-left: 0px;
  margin-right: 190px;
  margin-bottom: 50px;
}
</style>
